// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 52%;
}
@media (max-width: 1024px) {
  .options-container {
    width: 70%;
  }
}
.options-container .options {
  width: 81%;
  border-radius: 4px;
  border: 2px solid black;
}
@media (max-width: 1024px) {
  .options-container .options {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared-component/AdministrationDropdown/style.scss"],"names":[],"mappings":"AAAI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AACR;AACQ;EANJ;IAOQ,UAAA;EAEV;AACF;AACQ;EACI,UAAA;EACA,kBAAA;EACA,uBAAA;AACZ;AACY;EALJ;IAMQ,WAAA;EAEd;AACF","sourcesContent":["    .options-container {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        flex-direction: row;\r\n        width: 52%;\r\n\r\n        @media (max-width:'1024px') {\r\n            width: 70%;\r\n\r\n        }\r\n\r\n        .options {\r\n            width: 81%;\r\n            border-radius: 4px;\r\n            border: 2px solid black;\r\n\r\n            @media (max-width:'1024px') {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
